import moment from "jalali-moment";

export function toJalaliDate(
    date: Date | string,
    format: string = "YYYY/MM/DD"
): string | null {
    try {
        return moment(date).locale("fa").format(format);
    } catch {
        return null;
    }
}

export function getHumanReadableDiff(date: string): string {
    const hourDiff = moment(date).locale("fa").diff(moment(), "hours");
    const miniuteDiff = moment(date).locale("fa").diff(moment(), "minutes");

    if (miniuteDiff < 0) {
        return "ساعت انتخاب شده در گذشته است";
    }

    if (miniuteDiff > 0 && miniuteDiff < 60) {
        return `${miniuteDiff} دقیقه دیگر تا اجرای کمپین`;
    }

    if (hourDiff > 0 && hourDiff < 24) {
        return `${hourDiff} ساعت دیگر تا اجرای کمپین`;
    }

    if (hourDiff > 24) {
        return `تاریخ اجرای کمپین: ${moment(date)
            .locale("fa")
            .format("jYYYY/jM/jD HH:mm")}`;
    }
}

export function getAccountExpirationDateDiff(date: string) {
    const days = moment(date).locale("fa").diff(moment(), "days");
    const month = moment(date).locale("fa").diff(moment(), "month");

    if (month >= 1) {
        return `${month} ماه تا پایان اشتراک`;
    }

    if (days > 1) {
        return `${days} روز تا پایان اشتراک`;
    }

    return "کمتر از یک روز به پایان اشتراک شما زمان باقی است.";
}

export function getPhaseLastUpdateDateDiff(date: string): {
    value: number;
    description: string;
    type: "month" | "day";
} {
    const days = moment().diff(moment(date).locale("fa"), "days");
    const month = moment().diff(moment(date).locale("fa"), "month");

    if (month >= 1) {
        return { value: month, description: ` ${month} ماه `, type: "month" };
    }

    return { value: days, description: ` ${days} روز `, type: "day" };
}

export function processSmsCampaignDateChange(date: string): string {
    return moment(date).startOf("D").add(9, "h").toJSON();
}

export function getCurrentDate(withAdditionalDays: number = 0): Date {
    return moment().add("day", withAdditionalDays).locale("fa").toDate();
}

export function getCurrentDateStr(withAdditionalDays: number = 0): string {
    return moment()
        .add("day", withAdditionalDays)
        .locale("fa")
        .toDate()
        .toJSON();
}
